import crypto from "crypto"
import { webUrl } from "../automation/prepareEmails/webUrl"

const salt = "ZfUmxrayVqnQWd7"

export const createShortHash = (data: string, length = 16): string => {
  return crypto.createHash("sha256").update(`${data}${salt}`).digest("hex").slice(0, length)
}

export const collectDataForToken = (regId: string | number, studentEmail?: string, legalRepresentativeEmail?: string): string => {
  const data = [...new Set([regId, studentEmail, legalRepresentativeEmail])].filter(Boolean).map((v) => String(v).toLowerCase())

  return data.join("|")
}

export const getCourseOnlineLinkWithToken = (regId: string | number, studentEmail: string, legalRepresentativeEmail?: string): string =>
  `${webUrl}/online/${createShortHash(collectDataForToken(regId, studentEmail, legalRepresentativeEmail))}`
